<div class="container-header-cliente">
  <div class="content-header">
    <div class="info-photo">
      <div class="container-info">
        <div class="photo">
          <div
            class="
              font-omicron-bold
              content-photo
              background-color-omicron
              color-img-photo
            "
          >
            <span *ngIf="clientDoctorModel.photoUrl === ''">
              {{ clientDoctorModel.initialsName }}
            </span>
            <img
              [src]="clientDoctorModel.photoUrl"
              alt="client-photo"
              class="profile-photo-img"
              *ngIf="clientDoctorModel.photoUrl"
            />
          </div>
        </div>
        <div class="info row">
          <div
            class="
              padding-top-item
              font-omicron-bold
              color-omicron
              font-size-title
              col-sm-12 col-md-12 col-lg-12
              title-size-4
            "
          >
            Dr.{{ clientDoctorModel.name }}
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <div
              class="
                padding-top-item
                font-omicron-bold
                color-item-text
                font-size-item
                text-size-1
              "
            >
              {{ clientDoctorModel.speciality }}
            </div>
            <div
              class="
                padding-top-item
                font-omicron-medium
                color-text-grey
                font-size-item
                text-size-2
              "
            >
              Cédula: {{ clientDoctorModel.professionalLicense }}
            </div>
          </div>
          <div class="col-sm-12 col-md-6 col-lg-3">
            <div
              class="
                padding-top-item
                font-omicron-medium
                color-text-grey
                font-size-item
                text-size-2
              "
            >
              Tel: {{ clientDoctorModel.telephone }}
            </div>
            <div
              class="
                padding-top-item
                font-omicron-medium
                color-text-grey
                font-size-item
                text-size-2
                client-email
              "
            >
              {{ clientDoctorModel.email }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
